import { FC, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { AUTH_PATH } from '~/app/lib/paths'

const SignUpPage: FC = () => {
  const navigate = useNavigate()

  useEffect(() => {
    navigate(AUTH_PATH.SIGN_IN, { replace: true })
  }, [navigate])

  return null
}

export default SignUpPage
